import { render, staticRenderFns } from "./pelatihan.vue?vue&type=template&id=070e4aa4&"
import script from "./pelatihan.vue?vue&type=script&lang=js&"
export * from "./pelatihan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports